// --------------- LIBRARIES ---------------
import { put, call, takeEvery, all } from 'redux-saga/effects'

// --------------- ASSETS ---------------
import { GetInfluencers, GetInfluencer, ChangeInfluencerStatus } from '../Types'
import { getInfluencers, getInfluencer, changeInfluencerStatus } from '../actions'
import Api from '../../services/Api'

const getInfluencersSaga = function* getInfluencersSaga({ params }) {
  try {
    const response = yield call(Api.getInfluencers, params)
    // if (response?.status == '1') {
    yield put(getInfluencers.Success(response))
    // } else yield put(getUserProfile.Failed(response))
  } catch (error) {
    yield put(getInfluencers.Failed(error))
  }
}

const getInfluencerSaga = function* getInfluencerSaga({ params }) {
  try {
    const response = yield call(Api.getInfluencer, params)
    yield put(getInfluencer.Success(response))
  } catch (error) {
    yield put(getInfluencer.Failed(error))
  }
}

const changeInfluencerStatusSaga = function* changeInfluencerStatusSaga({ params }) {
  try {
    const response = yield call(Api.changeInfluencerStatus, params)
    yield put(changeInfluencerStatus.Success(response))
  } catch (error) {
    yield put(changeInfluencerStatus.Failed(error))
  }
}

function* influencerSaga() {
  yield all([
    takeEvery(GetInfluencers.REQUEST, getInfluencersSaga),
    takeEvery(GetInfluencer.REQUEST, getInfluencerSaga),
    takeEvery(ChangeInfluencerStatus.REQUEST, changeInfluencerStatusSaga),
  ])
}

export default influencerSaga
